





























import HeaderBar from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Banner from "@/components/Banner.vue";
import PieChart from "@/components/PieChart.vue";
import LadderDiagram from "@/components/LadderDiagram.vue";
import {Component, Prop, Vue} from "vue-property-decorator";
import Problem from "@/components/problem.vue";
import Web3 from "web3";
import {State, Action, Getter, Mutation} from "vuex-class";

@Component({components: {HeaderBar, Footer, Banner, PieChart, LadderDiagram, Problem}})
export default class App extends Vue {



    private ethereum = window['ethereum'];

    created(): void {
        this.init();


    }

    async init() {

        if (this.ethereum) {
            try {
                let bb = await this.ethereum.enable();
            } catch (error) {
                console.log(error);
            }
        } else if (window['web3']) {
            // eslint-disable-next-line no-undef
            window['web3'] = new Web3( window['web3'].currentProvider);

        }else {
            console.log("Non-Ethereum browser detected. You should consider trying MetaMask!");
        }

    }


}
